export enum DocumentType {
  /**
   * 竞价预告
   */
  ANNOUNCEMENT_APPLY = 0,
  /**
   * 成交公告
   */
  ANNOUNCEMENT_TRANSACTION = 1,
  /**
   * 供需审核-供应
   */
  SUPPLY = 2,
  /**
   * 供需审核-需求
   */
  DEMAND = 3,
  /**
   * 网站公告
   */
  SYSTEM_NOTICE = 4,
  /**
   * 行业资讯
   */
  NEWS = 5,
  /**
   * 帮助文档
   */
  SUPPORT = 6
}

export const DocumentTypeTextMap = {
  [DocumentType.ANNOUNCEMENT_APPLY]: '竞价预告',
  [DocumentType.ANNOUNCEMENT_TRANSACTION]: '成交公告',
  [DocumentType.SUPPLY]: '供应信息',
  [DocumentType.DEMAND]: '需求信息',
  [DocumentType.SYSTEM_NOTICE]: '网站公告',
  [DocumentType.NEWS]: '行业资讯',
  [DocumentType.SUPPORT]: '帮助文档'
}
